import DOMPurify from 'dompurify';
import makeClasses from './styles';
import React from 'react';

const SanitizedHtml = ({ html, removeInlineStyles = false }) => {
  const classes = makeClasses();

  const buildConfig = () => {
    return removeInlineStyles ? { FORBID_ATTR: ['style'] } : {};
  };

  return (
    <div
      className={classes.container}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html, buildConfig()),
      }}
    />
  );
};

export default SanitizedHtml;
